import { render } from "./UpdateMenuModifier.vue?vue&type=template&id=1e887b05&scoped=true"
import script from "./UpdateMenuModifier.vue?vue&type=script&lang=js"
export * from "./UpdateMenuModifier.vue?vue&type=script&lang=js"

import "./UpdateMenuModifier.vue?vue&type=style&index=0&id=1e887b05&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e887b05"]])

export default __exports__